import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
export const TicketDelete = ({ ticket, onDeletion }) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
    new rest.TicketService(ticket.url)
      .makeDeleteRequest()
      .then((response) => {
        onDeletion(ticket)
        dispatch(
          showSuccessToast(`Deleted Ticket ${ticket.reference_number}`, '')
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            `Could not delete Ticket ${ticket.reference_number}`,
            errors.response.data
          )
        )
      })
  }
  let message = `Are you sure you want to delete ${ticket.reference_number}?`
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body={message}
        confirmText={`Delete ${ticket.reference_number}?`}
        confirmBSStyle="danger"
        title="Deleting Organization"
      >
        <ReactBootstrap.NavDropdown.Item block size="sm">
          <i class="fa fa-trash" aria-hidden="true"></i> Delete
        </ReactBootstrap.NavDropdown.Item>
      </components.Confirm>
    </>
  )
}
